import React from 'react';
import { commonConstants } from 'constants/index';

const AppRibbon = () => {
  const config = commonConstants.RIBBON_CONFIGS[window.ENV_MODE];

  if (!config) return null;

  return <div className={`app-ribbon ${config.className}`}>{config.name}</div>;
};

export default AppRibbon;
